import NavBar from '../components/NavBar';
import Inserat from '../components/Inserat';
import { useTranslation } from 'react-i18next';
import CarierPlaceholder from '../components/CarierPlaceholder';

import motherboardImage from '../img/mother-board.jpg';
import blueprintImage from '../img/blueprint.jpg';

export default function ContactPage() {
  const { t } = useTranslation();
  return (
        <div class="grid">

          <Inserat name={t("ele_inserat_n")} image={motherboardImage}
                   requirements={t("ele_inserat_r")}
                   focus={t("ele_inserat_f")}
                   positionInfo={t("ele_inserat_i")}
                                  />
          <Inserat name={t("kons_inserat_n")} image={blueprintImage}
                   requirements={t("kons_inserat_r")}
                   focus={t("kons_inserat_f")}
                   positionInfo={t("kons_inserat_i")}
                                  />

          <CarierPlaceholder/>

          <NavBar location="carier"/> {/*je až nakonci aby byl opravdu nad všemi elementy */}
        </div>
  )
}